/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import _set from 'lodash/set';
import { updateUser } from '../actions/user';

export const updateRequiredField = createAsyncThunk(
  'role/updateRequiredField',
  async ({ roleId, fieldTitle, value }, {
    extra: { sdk, Toast, localization: l10n },
    getState,
    dispatch,
  }) => {
    try {
      await sdk.roles.updateRequiredField(roleId, fieldTitle, value);

      /** update user role if needed */
      const { user, roles } = getState();
      const isCurrentUserRole = user.role?._id === roleId;
      if (isCurrentUserRole) {
        const role = roles.items.find(({ _id }) => roleId === _id);
        if (role) dispatch(updateUser({ role }));
      }
    } catch (error) {
      Toast(l10n.TOAST.REQUIRED_FIELDS.UPDATE, { autoClose: false, type: 'error' });
      throw error;
    }
  },
);

export const reducer = (builder) => builder
  .addCase(
    updateRequiredField.pending,
    (state, { meta: { arg: { roleId, fieldTitle, value } } }) => {
      state.items.forEach((role) => {
        if (role._id === roleId) {
          if (!role.requiredFields) role.requiredFields = {};
          _set(role.requiredFields, fieldTitle, value);
        }
      });
    },
  )
  .addCase(
    updateRequiredField.fulfilled,
    () => {
      /** do nothing */
    },
  )
  .addCase(
    updateRequiredField.rejected,
    (state, { meta: { arg: { roleId, fieldTitle, value } }, error }) => {
      state.items.forEach((role) => {
        if (role._id === roleId) {
          _set(role.requiredFields, fieldTitle, !value);
        }
      });
      state.error = error;
    },
  );
